import { FileWarning } from "lucide-react";
import { useLanguage } from "../i18n";

/** Promemoria dati fiscali per aziende/dealer: senza anagrafica completa
 *  (ragione sociale, P.IVA, SDI) le fatture automatiche non escono corrette.
 *  Resta visibile finché il profilo fiscale non è completo. */
export default function KycReminderBanner({ onOpen }) {
  const { t } = useLanguage();
  return (
    <div data-testid="kyc-reminder-banner"
      className="mt-10 rounded-3xl border border-amber-200 bg-amber-50 px-6 py-5 flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-start gap-3 max-w-2xl">
        <div className="shrink-0 w-10 h-10 rounded-2xl bg-amber-100 flex items-center justify-center">
          <FileWarning className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <h3 className="font-display font-bold text-amber-900">{t("kycbanner.title")}</h3>
          <p className="text-sm text-amber-800/80 mt-0.5">{t("kycbanner.sub")}</p>
        </div>
      </div>
      <button data-testid="kyc-reminder-open" onClick={onOpen}
        className="rounded-full bg-amber-500 text-white px-6 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-widest hover:bg-amber-600 transition-colors">
        {t("kycbanner.cta")}
      </button>
    </div>
  );
}
